<template>
  <div id="app">
    <layout></layout>
  </div>
</template>

<script>
import Layout from './components/Layout'
// eslint-disable-next-line
import Modernizr from 'modernizr'

export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style lang="scss">
@import "./assets/scss/main";

#app {
  min-height: 100vh;
  min-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue